import React, { useContext } from "react";
import ReactDOM from "react-dom";
import { useSearchParams } from "react-router-dom";
import { Grid } from "@mui/material";
import { PortalProps } from "./interfaces";
import { Tab, StyledTabs } from "./styles";
import MultipleTabsExtension from "./MultipleTabsExtension";
import { MultipleTabsContext } from "./MultipleTabs";
import { SPACING } from "src/_globalStore/redux/reducers/Theme/themeConstants";
import { useTranslation } from "react-i18next";

const MultipleTabsPortal = ({ panels, value, handleChangeValue }: PortalProps) => {
  const { t } = useTranslation();
  const [, setSearchParams] = useSearchParams();
  const { maxDisplayedTabs } = useContext(MultipleTabsContext);
  const setRoutePath = (routePath: string | undefined): void => {
    if (!routePath) return;

    setSearchParams({ tab: routePath });
  };

  const portal = document.getElementById("MultitabsHorizontal-Portal") as HTMLElement;

  return portal
    ? ReactDOM.createPortal(
        <Grid
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            marginBottom: `${SPACING[7]}px`,
          }}
        >
          <Grid
            style={{
              display: "flex",
              gap: `${SPACING[3]}px`,
              alignItems: "center",
            }}
          >
            <StyledTabs
              value={value}
              onChange={(_, value) => handleChangeValue(value)}
              orientation={"horizontal"}
              isExtension={false}
              TabIndicatorProps={{
                style: {
                  width: "48px",
                },
              }}
              maxDisplayedTabs={maxDisplayedTabs}
            >
              {panels.map(({ tabLabel, tabIcon, routePath, tabLabelRootPath }, idx) => (
                <Tab
                  style={{
                    margin: 0,
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                  }}
                  key={idx}
                  label={tabLabelRootPath ? `${t(tabLabelRootPath)}` : tabLabel}
                  iconPosition={"start"}
                  disableRipple={true}
                  onClick={() => setRoutePath(routePath)}
                  title={tabLabel}
                  wrapped
                />
              ))}
            </StyledTabs>

            {panels.length > maxDisplayedTabs && (
              <MultipleTabsExtension
                panels={[...panels]}
                value={value}
                handleChangeValue={handleChangeValue}
                setRoutePath={setRoutePath}
              />
            )}

            <div id="MultipleTabs-chartToggler"></div>
          </Grid>

          <div id="Additional-info-in-multitabs-row"></div>
        </Grid>,
        portal
      )
    : null;
};

export default MultipleTabsPortal;
